import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/services/api";
import { handleApiError, handleApiSuccess } from "@/utils/errorHandler";
import i18n from "@/i18n/config";

export function useInboxCaptures() {
  return useQuery({
    queryKey: ["trackcast", "inbox"],
    queryFn: () => apiClient.listInbox(),
  });
}

export function useAssignCapture() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (vars: { captureId: string; sessionId: string }) =>
      apiClient.assignCapture(vars.captureId, vars.sessionId),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: ["trackcast", "inbox"] });
      queryClient.invalidateQueries({ queryKey: ["sessions"] });
      queryClient.invalidateQueries({ queryKey: ["dashboard"] });
      handleApiSuccess(
        i18n.t("pages:inbox.assignSuccess", {
          streams: result.streamsAssigned,
          videos: result.videosAssigned,
        }),
      );
    },
    onError: (error) => {
      handleApiError(error, i18n.t("pages:inbox.assignError"));
    },
  });
}

export function useDeleteCapture() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (vars: { captureId: string }) =>
      apiClient.deleteCapture(vars.captureId),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: ["trackcast", "inbox"] });
      queryClient.invalidateQueries({ queryKey: ["my-live-streams"] });
      handleApiSuccess(
        i18n.t("pages:inbox.deleteSuccess", {
          streams: result.streamsDeleted,
          videos: result.videosDeleted,
        }),
      );
    },
    onError: (error) => {
      handleApiError(error, i18n.t("pages:inbox.deleteError"));
    },
  });
}
